export default __webpack_public_path__ + "static/media/slider4.a3a55955.jpeg";